import styled from '@emotion/styled'
import Link from '../Link'

export const LinkButton = styled(Link)`
  &:link,
  &:visited,
  &:active,
  &:hover {
    text-decoration: none;
  }

  ${({ visibility, theme }) =>
    visibility === 'mobile only' &&
    `
    @media (min-width: ${theme.breakpoints.sm}) {
      display: none !important;
    }
  `}

  ${({ visibility, theme }) =>
    visibility === 'desktop only' &&
    `
    @media (max-width: ${theme.breakpoints.sm}) {
      display: none !important;
    }
  `}

  ${({ hideCobra }) =>
    hideCobra &&
    `
    display: none !important;
  `}
`
